'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Img = require('../../01.atoms/Img/Img.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-comparison',
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Comparison(_ref) {
  var animate = _ref.animate,
      headline = _ref.headline,
      items = _ref.items,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), !!style))
  }, headline && /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, items.map(function (_ref2, i) {
    var title = _ref2.title,
        content = _ref2.content,
        srcset = _ref2.srcset;
    return /*#__PURE__*/React__default.createElement("div", {
      className: cnCol,
      key: i
    }, /*#__PURE__*/React__default.createElement(Img, {
      srcset: srcset,
      animate: animate
    }), /*#__PURE__*/React__default.createElement("h4", null, title), /*#__PURE__*/React__default.createElement(RichText, {
      content: content
    }));
  })));
}
Comparison.propTypes = {
  /** True if should be animated */
  animate: PropTypes.bool,

  /** Title of Comparison */
  headline: PropTypes.string,

  /** Array of items to be compared */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    srcset: PropTypes.shape()
  })).isRequired,

  /** Theme */
  style: PropTypes.oneOf(['light', 'dark'])
};
Comparison.defaultProps = {
  items: []
};

module.exports = Comparison;
